// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 384 ? "jspdf" : chunkId) + "." + {"239":"4a6481c0","355":"3a0441b2","384":"e6f5cb0e","453":"eb756c48","732":"f9f57a28","977":"ba1aab09"}[chunkId] + ".chunk.js";
};